// src/types/KnowledgeBase.ts

export interface KnowledgeBase {
  ticketId: string;
  ticketCreationDatetime: string;
  ticketClosureDatetime: string;
  knowledgeBaseStartDatetime: string;
  knowledgeBaseCloseDatetime: string;
  networkId: string | number | undefined;
  siteId: string | number | undefined;
  linkId: string | number | undefined;
  assetId: string | number | undefined;
  teamId: string | number | undefined;
  personId: string | number | undefined;
  communicationWithCustomer: string;
  userid: any;
  ticketCreation: string;
  ticketClosure: string;
  summary: string;
  solution: string;
  affectedCustomer: string[];
  affectedNetwork: string[];
  affectedSite: string[];
  affectedLink: string[];
  asset: string;
  createdby: string;
  status: string;
  journalUpdate: string;
  communication: string;
  description: string;

  foruserid: number[];
  filePath: File[] | null;
  uploadPath: string;
  relatedobject: string[];
  ticketcrossrefrencenumber: string;
  rootcause: string;
  closedby: string;
  knowledgeBaseCrossReference: string;
  closurecode: string;
}

export const initialKnowledgeBase: KnowledgeBase = {
  ticketId: "",
  userid: "",
  ticketCreation: "",
  ticketClosure: "",
  affectedCustomer: [],
  affectedNetwork: [],
  affectedSite: [],
  affectedLink: [],
  asset: "",
  summary: "",
  solution: "",
  description: "",
  createdby: "",
  status: "",
  journalUpdate: "",
  communication: "",
  ticketCreationDatetime: "",
  ticketClosureDatetime: "",
  knowledgeBaseStartDatetime: "",
  knowledgeBaseCloseDatetime: "",
  networkId: undefined,
  siteId: undefined,
  linkId: undefined,
  assetId: undefined,
  teamId: undefined,
  personId: undefined,
  communicationWithCustomer: "",
  foruserid: [],
  filePath: [],
  uploadPath: "",
  relatedobject: [],
  ticketcrossrefrencenumber: "",
  rootcause: "",
  closedby: "",
  knowledgeBaseCrossReference: "",
  closurecode: "",
};
